import Noop from '../utils/noop';

/* eslint-disable @typescript-eslint/no-unused-vars */
export const mockedAnalytics = {
  track: Noop,
} as any as SegmentAnalytics.AnalyticsJS;
